import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CHECKOUT_URL, OFFER } from '../data/checkout';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-black relative overflow-hidden" data-id="element-91" data-mp="c70xh92updo1">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold-dark/10 via-black to-black pointer-events-none" data-id="element-92" data-mp="8573fjn5v7wu"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-93" data-mp="m2lv6v0vzrrz">
        <div className="text-center mb-16" data-id="element-94" data-mp="h52i3yfxdl1m">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-95" data-mp="vurwivd13lju">
            El próximo lunes puedes seguir improvisando...
            <br data-id="element-96" data-mp="qwztp6auif0v" />
            <span className="text-gold-gradient" data-id="element-97" data-mp="qw6sslykijqn">
              O puedes entrar al aula con todo listo desde hoy.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-dark-card p-8 rounded-2xl border border-dark-border" data-id="element-98" data-mp="zwmtjnnxfcrt">
            {['Sin más noches buscando cómo explicar conceptos metodológicos complejos', 'Sin más clases armadas de apuro con material que no funciona', 'Sin más alumnos desconectados que no entienden para qué sirve la metodología', 'Sin más fines de semana perdidos construyendo material desde cero', 'Sin más silencios incómodos frente a preguntas que te ponen en aprietos'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-99" data-mp="301tyod1cqc30" data-mpi={i}>
                <span className="text-gold mt-1" data-id="element-100" data-mp="30095oruor179">▸</span>
                <span className="text-gray-300" data-id="element-101" data-mp="34un3t20qfmfm">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-white mb-2" data-id="element-102" data-mp="39rvp3bh6g6l3">
            El Mega Pack Metodología de la Investigación 360 no te convierte en
            mejor docente.
          </p>
          <p className="text-2xl font-bold text-gold mb-6" data-id="element-103" data-mp="3isbr0gi9v5nu">
            Vos ya eres un buen docente.
          </p>
          <p className="text-xl text-gray-300 mb-16" data-id="element-104" data-mp="1jp4tzpvaoznc">
            Lo que hace el Mega Pack es darte el tiempo y las herramientas para
            que eso se note en cada clase.
          </p>
        </div>

        <div className="bg-black border-2 border-gold/30 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(212,175,55,0.1)]" data-id="element-105" data-mp="1shggx1r7a4yk">
          <h3 className="text-2xl font-bold text-white mb-6 text-center border-b border-dark-border pb-6" data-id="element-106" data-mp="1nnu3v8h4jz28">
            Todo lo que incluye:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-107" data-mp="1xgjgw7sbpkzo">
            {['Tomo 1 — Fundamentos de la metodología', 'Tomo 2 — Planteamiento del problema', 'Tomo 3 — Marco teórico y revisión', 'Tomo 4 — Tipos, enfoques y diseños', 'Tomo 5 — Población, muestra, técnicas', 'Tomo 6 — Análisis y presentación', 'Bono 1 — Banco de Evaluaciones', 'Bono 2 — Glosario Completo', 'Bono 3 — Manual de Respuestas', 'Bono 4 — Mapa Visual del Proceso', 'Garantía de 7 días sin preguntas', 'Pago en tu moneda local', 'Acceso inmediato', 'Formato PDF listo para usar'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-108" data-mp="3u9ua9ql1obx5" data-mpi={i}>
                <Check size={18} className="text-gold shrink-0" data-id="element-109" data-mp="3fdczp1koj1bn" />
                <span className="text-sm text-gray-200" data-id="element-110" data-mp="3fc1wp3z25xll">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-111" data-mp="3kad99mgqmm7i">
            <div className="mb-8 p-6 bg-gold/5 rounded-xl border border-gold/20 italic text-gray-300 text-lg" data-id="element-112" data-mp="36dghnissp0pk">
              "El mejor momento para tener este material era al inicio del año.
              <br data-id="element-113" data-mp="14kscv50i657o" />
              <span className="text-gold font-bold not-italic" data-id="element-114" data-mp="14md86wun5s6l">
                El segundo mejor momento es hoy.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold text-white mb-2" data-id="element-115" data-mp="35nazknsgo68g">
              📚 Mega Pack Metodología de la Investigación 360
            </p>
            <p className="text-sm text-gray-400 mb-8" data-id="element-116" data-mp="30ozqwgdwk1rt">
              Hecho por especialistas, para docentes de todo el mundo
              hispanohablante.
            </p>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: OFFER.name,
                value: OFFER.price,
                currency: OFFER.currency
              });
            }
          }} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-117" data-mp="2rmqhxuya8ggj">
              🟡 QUIERO MI MEGA PACK AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500" data-id="element-118" data-mp="1z05rcwpms8e1">
              <span data-id="element-119" data-mp="ehv87444yicc">✅ Garantía de 7 días</span>
              <span data-id="element-120" data-mp="egsfcqn965ts">✅ Pago seguro</span>
              <span data-id="element-121" data-mp="jfnbsve57swd">✅ Acceso inmediato</span>
              <span data-id="element-122" data-mp="jelo9rfxxdxr">✅ Pagas en tu moneda local</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}